import { yupResolver } from '@hookform/resolvers/yup';
import { format } from 'date-fns';
import { object, string } from 'yup';

import { IPauseMonitoringFormValues } from '../types';

const getCurrentDate = () => format(new Date(), 'yyyy-MM-dd');

const validationSchema = object().shape({
  startDate: string()
    .required('Field is required')
    .test(
      'start-date-not-in-past',
      'Start date should be greater than or equal to current date',
      startDate => {
        if (!startDate) return true;

        return startDate >= getCurrentDate();
      },
    ),
  endDate: string()
    .required('Field is required')
    .test(
      'end-date-not-in-past',
      'End date should be greater than or equal to current date',
      endDate => {
        if (!endDate) return true;

        return endDate >= getCurrentDate();
      },
    )
    .test('end-date-greater', 'End date should be greater than start date', (endDate, context) => {
      const { startDate } = context.parent as IPauseMonitoringFormValues;

      if (!startDate || !endDate) return true;

      return endDate > startDate;
    }),
  reason: string().trim().max(500, 'Max length - 500 symbols').required('Field is required'),
});

export default yupResolver(validationSchema);
